import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SheetViewCarouselStateService {
    private eventCarouselSubject$ = new BehaviorSubject<boolean>(false);

    setShowEventCarousel(val: boolean) {
        this.eventCarouselSubject$.next(val);
    }

    getShowEventCarousel(): Observable<boolean> {
        return this.eventCarouselSubject$.asObservable();
    }
}
